import { OperationsIDPage } from '@facephi/inphinite-operations';
import { useTranslation } from 'react-i18next';
import { useAntifraud } from '../providers';
import { RoutesNameAntifraud } from '../state/constants';

export const BannedIDPage = () => {
  const { t } = useTranslation();
  const { token } = useAntifraud();

  return (
    <OperationsIDPage
      hideReviewTab
      token={token || undefined}
      emptyBackRoute={RoutesNameAntifraud.banned}
      emptyBackText={t('Back to the banned list')}
    />
  );
};
